import React from 'react';
import { Carousel } from 'react-bootstrap';
import { ASSET_URL } from '../../../../env/Configurations';
import './Hero-Banner-With-Title-Preview.scss';

const HeroBannerWithTitlePreview = (props) => {
  const { config } = props;
  return (
    <div className='hero-banner-title'>
      {config?.slides?.length && (
        <Carousel controls={false}>
          {config.slides.map((slide, key) => (
            <Carousel.Item key={key} indicators variant='dark'>
              {!slide?.isVideo && (
                <div
                  className={`d-flex align-items-center ${
                    slide?.shadowOverlay ? 'shadowed-img' : ''
                  }`}
                  key={key}
                  style={
                    slide.imgURL
                      ? {
                          backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                          backgroundSize: 'cover',
                          height: '300px',
                          objectFit: 'cover',
                          width: '100%',
                          backgroundRepeat: 'no-repeat',
                        }
                      : {
                          backgroundRepeat: 'no-repeat',
                          height: '300px',
                        }
                  }
                >
                  <div style={slide.imgURL ? { color: 'white' } : { color: 'black' }}>
                    {!slide.imgURL && <p className='image-text'>Image</p>}
                    <p className='hero-banne-title'>{slide.titleH2 ? slide.titleH2 : 'H2 Title'}</p>
                  </div>
                </div>
              )}
              {slide?.isVideo && (
                <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                  <div className='video-container'>
                    <video
                      style={{
                        width: '100%',
                        height: '300px',
                        objectFit: 'fill',
                        position: 'relative',
                        top: 0,
                        left: 0,
                      }}
                      autoPlay
                      loop={slide?.loopPlayBack}
                      preload='auto'
                      src={slide?.videoURL}
                      muted
                    />

                    <div style={slide.videoURL ? { color: 'white' } : { color: 'black' }}>
                      {!slide.videoURL && <p className='image-text'>Video</p>}
                      <p className='hero-banner-title-2'>
                        {slide.titleH2 ? slide.titleH2 : 'H2 Title'}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default HeroBannerWithTitlePreview;
